import React, { useEffect } from 'react'
import { connect } from 'react-redux';
import DatePicker from "react-datepicker";

import BackButton from '../../components/BackButton';
import { IProductType } from '../../shared/models/mainDashboardModel';
import { getReportsType, getReportsProductsType, updateReportForm, getReportDetail, updateValidationObj, resetReportFilter } from '../../store/actions/reports';
import ReportViewer from './report_viewer';
import { ReportType } from '../../shared/models/reportModels';

import './reports.styles.css';
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';
import { MESSAGES } from '../../services/constants';

interface IProps {
  getReportsType: Function;
  getReportsProductsType: Function;
  reportsType: [];
  reportsProductsType: IProductType[];
  reportForm: any;
  updateReportForm: Function;
  getReportDetail: Function;
  validations: any;
  updateValidationObj: Function;
  isFetching: any;
  reportDetail: any;
  finalReportFormData: any;
  resetReportFilter: Function;
}

const Report = (props: IProps) => {
  const {
    reportsType,
    reportsProductsType,
    reportForm,
    getReportsType,
    getReportsProductsType,
    updateReportForm,
    getReportDetail,
    validations,
    updateValidationObj,
    isFetching,
    reportDetail,
    finalReportFormData,
    resetReportFilter
  } = props;

  const {
    reportEnum = 1,
    productTypeFilter = 0,
    from = '',
    to = '',
    createdFrom = '',
    createdTo = '',
  } = reportForm;

  useEffect(() => {
    getReportsType();
    getReportsProductsType();
    resetFilter();
  }, []);

  const handleOnChange = (e: any) => {
    updateReportForm({
      [e.target.name]: isNaN(e.target.value) ? e.target.value : Number(e.target.value)
    });
  }

  const handleDateSelection = async (value: any, fieldName: string) => {
    
    await updateReportForm({
      [fieldName]: value
    });
  }

  const checkFieldIsValid = (fieldName: string) => {
    let controlIsValid = true;
    // return new Promise((resolve, reject) => {
      try {
        if (validations[fieldName].isDate) {
          // check date is valid
          if (!moment(reportForm[fieldName]).isValid()) {
            controlIsValid = false;
            validations[fieldName].errorMessage.invalid = MESSAGES.invalidDate;
          } else {
            validations[fieldName].errorMessage.invalid = '';
          }

          //check is lessThanOrEqualTo To date
          if (
            controlIsValid &&
            validations[fieldName] &&
            validations[fieldName].lessThanOrEqualTo &&
            reportForm[validations[fieldName].lessThanOrEqualTo]
            && (!moment(reportForm[fieldName]).isSameOrBefore(reportForm[validations[fieldName].lessThanOrEqualTo]))
          ) {
            controlIsValid = false;
            validations[fieldName].errorMessage.min = MESSAGES.formDate;
          } else if (validations[fieldName].lessThanOrEqualTo && !reportForm[validations[fieldName].lessThanOrEqualTo]) {
            controlIsValid = false;
            validations[validations[fieldName].lessThanOrEqualTo].errorMessage.invalid = MESSAGES.invalidDate;
          } else {
            validations[fieldName].errorMessage.min = '';
          }

          //check is greaterThanOrEqualTo from date
          if (
            controlIsValid &&
            validations[fieldName] &&
            validations[fieldName].greaterThanOrEqualTo &&
            reportForm[validations[fieldName].greaterThanOrEqualTo] &&
            validations[fieldName].greaterThanOrEqualTo
            && (!moment(reportForm[fieldName]).isSameOrAfter(reportForm[validations[fieldName].greaterThanOrEqualTo]))
          ) {
            controlIsValid = false;
            validations[fieldName].errorMessage.max = MESSAGES.toDate;
            // validations[fieldName].isValid = false
          } else if (validations[fieldName].greaterThanOrEqualTo && !reportForm[validations[fieldName].greaterThanOrEqualTo]) {
            controlIsValid = false;
            validations[validations[fieldName].greaterThanOrEqualTo].errorMessage.invalid = MESSAGES.invalidDate;
          } else {
            validations[fieldName].errorMessage.max = '';
          }

          validations[fieldName].isValid = controlIsValid
        }
        
        return controlIsValid;
        // resolve(controlIsValid);
      } catch (e) {
        console.error(e);
        // reject(e);
      }
    // });
  }

  const handleSubmit = (e: any) => {
    e.preventDefault();
    let isFormValid = true;
    Object.keys(validations).map( (fieldName) => {
      if (reportForm[fieldName]) {
        checkFieldIsValid(fieldName);
        if (!validations[fieldName].isValid) {
          isFormValid = false;
        }
      }
      else if (!reportForm['from'] && !reportForm['to']) {
          validations[fieldName].errorMessage.invalid = ''
          validations[fieldName].errorMessage.min = ''
          validations[fieldName].errorMessage.max = ''
      }
      else if (!reportForm['createdFrom'] && !reportForm['createdTo']) {
        validations[fieldName].errorMessage.invalid = ''
        validations[fieldName].errorMessage.min = ''
        validations[fieldName].errorMessage.max = ''
    }
    });

    updateValidationObj({...validations});

    // if valid then get report detail
    if (isFormValid) {
      getReportDetail({...reportForm});
    }
  }

  const getErrorMessage = (validationsObj: any, fieldName: string) => {
    const errorMsgObj = validationsObj[fieldName].errorMessage;
    return errorMsgObj.invalid
      || errorMsgObj.min || errorMsgObj.max || ''
  }
  const resetFilter = () => resetReportFilter();
 
  return (
    <div className='container-fluid'>
      <div className='page-header'>
        <h1>Reports</h1>
        <BackButton />
      </div>
      <div className='page-content'>
        <form className='row'>
          <div className='col-xl-12'>
            <div className='info-title box-shaddow box-padding border-btm-blue mb-5'>
              <div className='row report-filter'>
                <div className='col-xl-9 col-lg-12'>
                  <div className='row'>
                    <div className='col-md-3'>
                      <select
                        className="form-control selectpicker btn btn-light"
                        name="reportEnum"
                        onChange={handleOnChange}
                        value={reportEnum}
                      >
                        {reportsType.map((report: any) => (
                          <option key={report.id} value={report.id}>{report.name}</option>
                        ))}
                      </select>
                    </div>
                    <div className='col-md-3'>
                      <select
                        className='selectpicker btn btn-light form-control'
                        name='productTypeFilter'
                        onChange={handleOnChange}
                        value={productTypeFilter}
                      >
                        {
                          reportsProductsType.map((item: any) => (
                            <option key={item.id} value={item.id}>{item.name}</option>
                          ))
                        }
                      </select>
                    </div>
                    <div className='col-md-3'>
                      <DatePicker
                        placeholderText='Select From Date'
                        className='form-control'
                        selected={from}
                        dateFormat="dd-MMM-yyyy"
                        onChange={(value: any) => handleDateSelection(value, 'from')}
                        isClearable={true}
                        maxDate={moment().toDate()}
                      />
                      <div className='text-danger'>{getErrorMessage(validations, 'from')}</div>
                    </div>
                    <div className='col-md-3'>
                      <DatePicker
                        placeholderText='Select To Date'
                        className='form-control'
                        selected={to}
                        dateFormat="dd-MMM-yyyy"
                        onChange={(value: any) => handleDateSelection(value, 'to')}
                        isClearable={true}
                        maxDate={moment().toDate()}
                      />
                      <div className='text-danger'>{getErrorMessage(validations, 'to')}</div>
                    </div>
                    </div>
                    {reportEnum === ReportType.AverageTimeInstatusDataReport && 
                   <div  className='row mt-2'>
                      <div className='offset-6 col-md-3'>
                      <DatePicker
                        placeholderText='Select Created From Date'
                        className='form-control'
                        selected={createdFrom}
                        dateFormat="dd-MMM-yyyy"
                        onChange={(value: any) => handleDateSelection(value, 'createdFrom')}
                        isClearable={true}
                        maxDate={moment().toDate()}
                      />
                      <div className='text-danger'>{getErrorMessage(validations, 'createdFrom')}</div>
                    </div>

                    <div className='col-md-3'>
                    <DatePicker
                        placeholderText='Select Created To date'
                        className='form-control'
                        selected={createdTo}
                        dateFormat="dd-MMM-yyyy"
                        onChange={(value: any) => handleDateSelection(value, 'createdTo')}
                        isClearable={true}
                        maxDate={moment().toDate()}
                      />
                      <div className='text-danger'>{getErrorMessage(validations, 'createdTo')}</div>
                    </div>
                    </div>}
                </div>
                <div className='col-xl-3 col-lg-12 mt-xl-0 mt-3'>
                  <div className='row'>
                    <div className='col-md-8'>
                      <button
                        className='btn btn-primary gen-report w-100'
                        type='submit'
                        onClick={handleSubmit}
                      >
                        Run Report
                      </button>
                    </div>
                    <div className='col-md-4'>
                      <button
                        className='btn btn-secondary font-weight-bold'
                        type='button'
                        onClick={resetFilter}
                      >
                        Reset
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <ReportViewer 
              reportForm={{ ...finalReportFormData }}
              reportDetail={reportDetail}
              isFetching={isFetching}
            />
          </div>
        </form>
      </div>
    </div>
  )
}

const mapStateToProps = ({ report }: any) => ({
  isFetching: report.isFetching,
  reportsType: report.reportsType,
  reportsProductsType: report.reportsProductsType,
  reportForm: report.reportForm,
  validations: report.validations,
  reportDetail: report.reportDetail,
  finalReportFormData: report.finalReportFormData,
});

const mapDispatchToProps = (dispatch: any) => {
  return {
    resetReportFilter: () => dispatch(resetReportFilter()),
    getReportsType: () => dispatch(getReportsType()),
    getReportsProductsType: () => dispatch(getReportsProductsType()),
    updateReportForm: (reportForm: any) => dispatch(updateReportForm(reportForm)),
    getReportDetail: (params: any) => dispatch(getReportDetail(params)),
    updateValidationObj: (validationObj: any) => dispatch(updateValidationObj(validationObj))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Report);
